import { type PackagedEvent } from '../integration/types';

import { attachXidToSingleEvent } from './attachXidToSingleEvent';

import { type XIDItem } from './index';

// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
export async function attachXidToMultipleEvents(
	items: PackagedEvent[],
	xidItemPromiseCallback: Promise<() => XIDItem[]>,
): Promise<PackagedEvent[]> {
	try {
		const xidCallback = await xidItemPromiseCallback;
		return items.map((item) => attachXidToSingleEvent(item, xidCallback));
	} catch (error) {
		return items;
	}
}
